import { render, staticRenderFns } from "./NewPackageBlock.vue.html?vue&type=template&id=2f603fb4&"
import script from "./NewPackageBlock.component.js?vue&type=script&lang=vueJs&"
export * from "./NewPackageBlock.component.js?vue&type=script&lang=vueJs&"
import style0 from "./NewPackageBlock.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports